import styled from 'styled-components';
import { ThemeColors } from '@wyjehau/theme';

export const ButtonBase = styled.button`
	background: transparent;
	color: ${ThemeColors.black};
`;
